// Nova Eğitim Mock Data

export const logoUrl = "https://customer-assets.emergentagent.com/job_nova-egitim/artifacts/qndkz1va_Gemini_Generated_Image_xqgsjxqgsjxqgsjx.png";

export const contactInfo = {
  phone: "+90 542 155 24 33",
  whatsapp: "905421552433",
  address: "Portakal Mahallesi 80121 Sokak No:3/C Toroslar Mersin",
  mapQuery: "Portakal Mahallesi 80121 Sokak, Toroslar, Mersin"
};

export const services = [
  {
    id: 1,
    title: "Bire Bir Ders",
    description: "Öğrencinin ihtiyacına özel birebir ders programları ile maksimum verim.",
    icon: "UserCheck"
  },
  {
    id: 2,
    title: "Eğitim Koçluğu",
    description: "Motivasyon ve hedef odaklı profesyonel koçluk desteği.",
    icon: "Target"
  },
  {
    id: 3,
    title: "Deneme & Analiz",
    description: "Düzenli deneme sınavları ve detaylı analiz raporları.",
    icon: "BarChart3"
  },
  {
    id: 4,
    title: "Kişisel Çalışma Programı",
    description: "Her öğrenciye özel hazırlanan çalışma takvimi ve planı.",
    icon: "Calendar"
  },
  {
    id: 5,
    title: "Teknolojik Çalışma Alanı",
    description: "Modern teknoloji ile donatılmış konforlu çalışma ortamları.",
    icon: "Monitor"
  },
  {
    id: 6,
    title: "Veli Bilgilendirme",
    description: "Düzenli veli görüşmeleri ve anlık gelişim raporları.",
    icon: "Users"
  }
];

export const whyUs = [
  {
    id: 1,
    title: "Takip Edilebilir Sistem",
    description: "Öğrenci gelişimini adım adım izleyin ve raporlayın.",
    icon: "ClipboardCheck"
  },
  {
    id: 2,
    title: "Kişiye Özel Yaklaşım",
    description: "Her öğrencinin öğrenme stiline uygun eğitim metodu.",
    icon: "Heart"
  },
  {
    id: 3,
    title: "Güçlü Analiz",
    description: "Veriye dayalı performans değerlendirmesi ve yönlendirme.",
    icon: "TrendingUp"
  },
  {
    id: 4,
    title: "Hızlı İletişim",
    description: "7/24 ulaşılabilir destek ve anlık bilgilendirme.",
    icon: "MessageCircle"
  }
];

export const galleryImages = [
  "https://i.hizliresim.com/6qsb05q.jpeg",
  "https://i.hizliresim.com/ay5r7cj.jpeg",
  "https://i.hizliresim.com/o2z5sng.jpeg",
  "https://i.hizliresim.com/k3cal77.jpeg",
  "https://i.hizliresim.com/qpmr9ro.jpeg",
  "https://i.hizliresim.com/4t56az6.jpeg",
  "https://i.hizliresim.com/rgbmqhb.jpeg",
  "https://i.hizliresim.com/84pp32l.jpeg",
  "https://i.hizliresim.com/jtc5wca.jpeg",
  "https://i.hizliresim.com/2amrqzr.jpeg",
  "https://i.hizliresim.com/iuksvzp.jpeg",
  "https://i.hizliresim.com/l1l77s4.jpeg",
  "https://i.hizliresim.com/ee5zvjq.jpeg",
  "https://i.hizliresim.com/3e2kj3r.jpeg",
  "https://i.hizliresim.com/8e02rae.jpeg",
  "https://i.hizliresim.com/7dc77ej.jpeg",
  "https://i.hizliresim.com/f6bky0t.jpeg",
  "https://i.hizliresim.com/7p3blil.jpeg"
];

export const menuItems = [
  { label: "Hizmetler", href: "#hizmetler" },
  { label: "Neden Biz?", href: "#neden-biz" },
  { label: "İletişim", href: "#iletisim" },
  { label: "Galeri", href: "/galeri" }
];
